import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./RestaurantCommentTable.module.scss";
import { Check2, XLg } from "react-bootstrap-icons";
const RestaurantCommentTable = ({ showAddress, data, rawInfo }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "اسم رستوران",
      dataIndex: "restaurantName",
      key: "restaurantName",
      width: "12.5%",
      ...getColumnSearchProps("restaurantName", "اسم رستوران"),
    },
    {
      title: "اسم مشتری",
      dataIndex: "customerName",
      key: "customerName",
      width: "12.5%",
      ...getColumnSearchProps("customerName", "اسم مشتری"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(5, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شهر",
      dataIndex: "city",
      key: "city",
      width: "12.5%",
      ...getColumnSearchProps("city", "شهر"),
    },
    {
      title: "زمان کامنت",
      dataIndex: "date",
      key: "date",
      width: "12.5%",
    },
    {
      title: "امتیاز",
      dataIndex: "score",
      key: "score",
      width: "12.5%",
    },
    {
      title: "لیست سفارشات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "12.5%",
      render: (text, record) => (
        <button
          onClick={() => showAddress(4, record)}
          className={Style.orderBtn}
        >
          نمایش سفارش
        </button>
      ),
    },
    {
      title: "نظر ",
      dataIndex: "comment",
      key: "comment",
      width: "12.5%",
      render: (text, record) => (
        <button onClick={() => showAddress(3, record)} className={Style.mapBtn}>
          نمایش نظر{" "}
        </button>
      ),
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "12.5%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          {record.status === "-1" ? (
            <p className={Style.reject}>رد شد</p>
          ) : (
            <button
              onClick={() => showAddress(1, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
          )}
          {record.status === "1" ? (
            <p className={Style.check}>تایید شد</p>
          ) : (
            <button onClick={() => showAddress(2, record)} className={Style.ok}>
              <Check2 />
            </button>
          )}
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data && data}
        responsive={true}
        scroll={{x:1500, y: 300 }}
      />
    </div>
  );
};

export default RestaurantCommentTable;
